var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"canvas_wrapper",attrs:{"id":"canvas_wrapper"}},[_c('canvas',{ref:"canvas",attrs:{"height":"1000px","width":"1000px","id":"canvas"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }